import { Button as RoccoButton } from '@rocco/components/button';
import { ReactComponent as FiltersIcon } from '@rocco/icons/svg/filters.svg';

interface CollapsibleToggleProps {
    filterDrawerOpen: boolean;
    toggleFilterDrawer: () => void;
}

export const CollapsibleToggle = ({
    filterDrawerOpen,
    toggleFilterDrawer,
}: CollapsibleToggleProps) => {
    return (
        <RoccoButton
            color="primary"
            aria-label={`${filterDrawerOpen ? 'Hide filters' : 'Filters'}`}
            onClick={toggleFilterDrawer}
            clickAnimation="scale"
            weight="normal"
        >
            <FiltersIcon className="size-4.5 mr-2" />
            {filterDrawerOpen ? 'Hide filters' : 'Show Filters'}
        </RoccoButton>
    );
};
